import { InjectionToken } from '@angular/core';

export interface SigninWithCodeData {
  token: string;
  is2faEnabled: boolean;
}

export interface Enable2FAData {
  qrCode: string;
  manualSetupUri: string;
  recoveryCodes: string[];
}

export interface AccessData {
  refresh: string;
  access: string;
  permissions: string[];
}

export type AuthSession = Omit<AccessData, 'permissions'>;

export const GOOGLE_CLIENT_ID = new InjectionToken<string>('GOOGLE_CLIENT_ID');
